<template>
  <q-field ref="fieldRef" :rules="computedRules" />
</template>

<script setup>
import { ref, computed, onMounted } from "vue"

import { useValidators } from "@/composables/useValidators.js"
import { useFieldsetState } from "@/composables/useFieldsetState.js"

const validators = useValidators()

const props = defineProps({
  rules: Array,
  disable: Boolean,
  readonly: Boolean,
  formStateInheritanceDisabled: Boolean,
  alwaysValidate: Boolean
})

const fieldRef = ref(null)

const { validationSkipped } = useFieldsetState(props)

// A form-level rule follows the same lock logic as the fields: when the enclosing form/card is
// locked (disabled or read-only) the rule is skipped - it is unreachable for the user - unless it
// opts in via always-validate.
const computedRules = computed(() => (validationSkipped.value ? [] : props.rules))

onMounted(() => validators.watchRules(computedRules, fieldRef))

const hasError = computed(() => fieldRef.value?.hasError ?? false)

defineExpose({ validate: () => fieldRef.value.validate(), hasError })
</script>

<style lang="scss" scoped>
.q-field {
  padding-bottom: 0;
  max-width: 400px;

  &:not(.q-field--error) {
    display: none;
  }
}

:deep(.q-field__control) {
  display: none;
}

:deep(.q-field__bottom) {
  position: relative;
  padding-top: 0;
  transform: none;
  min-height: 0;
}
</style>
